import React, { useEffect, useState } from "react";
import {
  Image,
  Table,
  Button,
  Segment,
  Icon,
  Message,
} from "semantic-ui-react";
import { Empty, Skeleton } from "antd";
import Container from "react-bootstrap/Container";
import axios from "axios";
import EmployeeForm from "./EmployeeForm";
import { Col, Row } from "react-bootstrap";
import EditEmployeeForm from "./EditEmployee";
import SearchInput from "../../common/SearchInput";
import UserCard from "../../common/UserCard";

function EmployeesData({ schoolId }) {
  const [employees, setEmployees] = useState([]);
  const [employee, setEmployee] = useState({});
  const [errors, setErrors] = useState({
    response: { show: false, type: "success", message: "" },
  });
  const [uuid, setId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showUser, setShowUser] = useState({ show: false, data: {} });
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isCreated, setCreated] = useState(false);
  const [isUpdated, setUpdated] = useState(false);
  const [isDeleted, setDeleted] = useState(false);
  const [page, setPage] = useState(1);
  const [disable, setDisable] = useState(false);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const token = localStorage.getItem("token");
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/employees/${schoolId}?page=${page}`,
          { headers: { token } }
        );
        setLoading(false);
        setEmployees(response.data.data);
      } catch (error) {
        setLoading(false);
        console.log(error);
        return error;
      }
    };

    fetchEmployees();
    return () => setCreated(false);
    // eslint-disable-next-line
  }, [isCreated, page, isDeleted, isUpdated]);

  const handleShowUser = (value) => {
    setShowUser({ show: true, data: value });
  };

  const handleDeleteEmp = async (empId) => {
    try {
      setId(empId);
      setIsLoading(true);
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/employees/${schoolId}/${empId}`,
        { headers: { token: localStorage.getItem("token") } }
      );
      setIsLoading(false);
      console.log(response);
      if (response.status === 200) {
        setIsLoading(false);
        setDeleted(true);
        return;
      }
    } catch (error) {
      setIsLoading(false);
      if (error.message === "Network Error") {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.message,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 403) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 404) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 500) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      setErrors({
        ...errors,
        response: {
          show: true,
          type: "error",
          message: error.response.data.error,
        },
      });
      return setTimeout(
        () => setErrors({ ...errors, response: { show: false } }),
        3000
      );
    }
  };

  return (
    <>
      {loading ? (
        <>
          <Skeleton.Button
            active
            shape='round'
            className='p-2'
            size='default'
          />
          <Skeleton active avatar paragraph={{ rows: 4 }} className='p-2' />
        </>
      ) : (
        <Container>
          <EmployeeForm
            showModal={showModal}
            setShowModal={setShowModal}
            setCreated={setCreated}
            schoolId={schoolId}
          />
          <EditEmployeeForm
            showModal={showEdit}
            setShowModal={setShowEdit}
            setUpdated={setUpdated}
            schoolId={schoolId}
            employee={employee}
          />
          <UserCard
            showModal={showUser}
            setShowModal={setShowUser}
            showUpdate={setShowEdit}
            setUser={setEmployee}
            deleteUser={handleDeleteEmp}
            processing={isLoading}
          />
          {employees.length === 0 ? (
            <Segment placeholder>
              <Empty>
                <Button
                  primary
                  onClick={() => {
                    setCreated(false);
                    setShowModal(true);
                  }}
                >
                  Add Employee
                </Button>
              </Empty>
            </Segment>
          ) : (
            <>
              <Container>
                <Row className='justify-content-center'>
                  <Col lg={9}>
                    <Button
                      basic
                      circular
                      positive
                      style={{ marginBottom: 10 }}
                      onClick={() => {
                        setCreated(false);
                        setShowModal(true);
                      }}
                    >
                      <Icon name='add' />
                      Add new
                    </Button>
                  </Col>
                  <Col>
                    <SearchInput data={employees} fn={handleShowUser} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Message
                      content={errors.response.message}
                      hidden={!errors.response.show}
                      positive={errors.response.type === "success"}
                      negative={errors.response.type === "error"}
                    />
                  </Col>
                  <Col lg={12}>
                    <Table color='blue' striped fixed columns={9}>
                      <Table.Header>
                        <Table.HeaderCell textAlign='center'>
                          Image
                        </Table.HeaderCell>
                        <Table.HeaderCell>First Name</Table.HeaderCell>
                        <Table.HeaderCell>Last Name</Table.HeaderCell>
                        <Table.HeaderCell>Email</Table.HeaderCell>
                        <Table.HeaderCell>Phone</Table.HeaderCell>
                        <Table.HeaderCell>Address</Table.HeaderCell>
                        <Table.HeaderCell>Role</Table.HeaderCell>
                        <Table.HeaderCell>Status</Table.HeaderCell>
                        <Table.HeaderCell>Actions</Table.HeaderCell>
                      </Table.Header>

                      <Table.Body>
                        {employees.map((employee) => {
                          return (
                            <Table.Row
                              key={employee.user.uuid}
                              negative={employee.status === "rejected"}
                            >
                              <Table.Cell
                                textAlign='center'
                                style={{
                                  border: "none",
                                }}
                              >
                                <Image
                                  src={`${
                                    employee.user.image
                                      ? employee.user.image
                                      : process.env.REACT_APP_DEF_IMAGE
                                  }`}
                                  avatar
                                />
                              </Table.Cell>
                              <Table.Cell style={{ border: "none" }}>
                                {employee.user.firstName}
                              </Table.Cell>
                              <Table.Cell style={{ border: "none" }}>
                                {employee.user.lastName}
                              </Table.Cell>
                              <Table.Cell style={{ border: "none" }}>
                                {employee.user.email}
                              </Table.Cell>
                              <Table.Cell style={{ border: "none" }}>
                                {employee.user.phone}
                              </Table.Cell>
                              <Table.Cell style={{ border: "none" }}>
                                {employee.user.address}
                              </Table.Cell>
                              <Table.Cell style={{ border: "none" }}>
                                {employee.user.role}
                              </Table.Cell>
                              <Table.Cell
                                warning={employee.status === "pending"}
                                style={{ border: "none" }}
                              >
                                {employee.status}
                              </Table.Cell>
                              <Table.Cell style={{ border: "none" }}>
                                <Button
                                  icon='edit'
                                  size='mini'
                                  circular
                                  primary
                                  onClick={() => {
                                    setUpdated(false);
                                    setEmployee(employee);
                                    setShowEdit(true);
                                  }}
                                />
                                <Button
                                  icon='trash'
                                  size='mini'
                                  circular
                                  negative
                                  loading={
                                    isLoading && employee.uuid === uuid
                                      ? true
                                      : false
                                  }
                                  onClick={() => handleDeleteEmp(employee.uuid)}
                                />
                                {/*  */}
                              </Table.Cell>
                            </Table.Row>
                          );
                        })}
                      </Table.Body>
                      <Table.Footer>
                        <Table.Row>
                          <Table.HeaderCell colSpan='9'>
                            <Button.Group floated='right'>
                              <Button
                                icon='angle left'
                                onClick={() => setPage(page - 1)}
                                disabled={disable || employees.length < 5}
                              />
                              <Button
                                onClick={(e) =>
                                  setPage(e.currentTarget.textContent)
                                }
                              >
                                1
                              </Button>
                              {Array.from({
                                length: Math.round(employees.length / 5),
                              }).map((_, index) => {
                                if (index === employees.length)
                                  return setDisable(!disable);
                                return (
                                  <Button
                                    content={index + 2}
                                    onClick={(e) =>
                                      setPage(e.currentTarget.textContent)
                                    }
                                    disabled={disable || employees.length < 5}
                                  />
                                );
                              })}
                              <Button
                                icon='angle right'
                                disabled={disable || employees.length < 5}
                                onClick={() => setPage(page + 1)}
                              />
                            </Button.Group>
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Footer>
                    </Table>
                  </Col>
                </Row>
              </Container>
            </>
          )}
        </Container>
      )}
    </>
  );
}

export default EmployeesData;
